export default __webpack_public_path__ + "b7509eaeb0d0f5d6a770deb987d4fc19.webp";